import { render, staticRenderFns } from "./SegmentedPickerTabs.vue?vue&type=template&id=5314a2f8"
import script from "./SegmentedPickerTabs.vue?vue&type=script&lang=js"
export * from "./SegmentedPickerTabs.vue?vue&type=script&lang=js"
import style0 from "./SegmentedPickerTabs.vue?vue&type=style&index=0&id=5314a2f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports